/**
 * возвращает заданное число {number}, если оно не выходит из заданных рамок,
 * либо мин значение, если число меньше минимума и максимальное, если больше максимума
 * в остальных случаях возвращает 0
 * @param {string | number} number проверяемое число
 * @param {number} min минимальная граница
 * @param {number} max максимальная граница
 *
 * @return {number}
 *
 * @example getLimitedNumber(10, 0, 5) => 5;
 * @example getLimitedNumber(3, 0, 5) => 3;
 * @example getLimitedNumber(-3, 0, 5) => 0;
 * @example getLimitedNumber('sdf', 0, 5) => 0;
 */

export const getLimitedNumber = (number: string | number, min: number, max: number) =>
	Math.max(min, Math.min(max, Number(number) || 0));
